import { Provider } from '@angular/core';
import {
    NGX_MAT_DATE_FORMATS,
    NgxMatDateFormats,
    NgxMatDatetimePickerModule,
    NgxMatNativeDateModule,
    NgxMatTimepickerModule,
} from '@angular-material-components/datetime-picker';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatButtonModule } from '@angular/material/button';
import { NgxMatDateAdapter } from '@angular-material-components/datetime-picker';
import { PrehoxNgxMatNativeDateAdapter } from './prehox-native-date-adapter';

/** Formato de exibição no input: dia/mês/ano + hora:minuto (24h). */
export const PREHOX_NGX_MAT_DATE_FORMATS: NgxMatDateFormats = {
    parse: {
        dateInput: 'DD/MM/YYYY HH:mm',
    },
    display: {
        dateInput: {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            hour12: false,
        },
        monthYearLabel: {
            year: 'numeric',
            month: 'short',
        },
        dateA11yLabel: {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
        },
        monthYearA11yLabel: {
            year: 'numeric',
            month: 'long',
        },
    },
};

/** Módulos para importar em components standalone que usam datetime. */
export const DATETIME_PICKER_IMPORTS = [
    NgxMatDatetimePickerModule,
    NgxMatTimepickerModule,
    NgxMatNativeDateModule,
    MatDatepickerModule,
    MatButtonModule,
];

export const DATETIME_PICKER_PROVIDERS: Provider[] = [
    { provide: NGX_MAT_DATE_FORMATS, useValue: PREHOX_NGX_MAT_DATE_FORMATS },
    { provide: NgxMatDateAdapter, useClass: PrehoxNgxMatNativeDateAdapter },
];
